<template>
  <div class="card">
    <div class="form">
      <h5>Details</h5>

      <Field
        :errors="goal.fieldErrors"
        :show-field-errors="goal.fieldErrors ? goal.fieldErrors.length > 0 : false"
        name="targetFunds"
      >
        <label for="goal-funds" class="label">Amount you're raising</label>
        <div class="amount-container">
          <span>$</span>
          <input
            id="goal-funds"
            v-model="goal.targetFunds"
            type="number"
            placeholder="0"
            required
          />
        </div>
      </Field>

      <Field
        :errors="goal.fieldErrors"
        :show-field-errors="goal.fieldErrors ? goal.fieldErrors.length > 0 : false"
        name="endDate"
      >
        <label for="goal-end-date" class="label">End Date for Milestone</label>
        <input
          id="goal-end-date"
          v-model="goal.endDate"
          class="input"
          type="datetime-local"
          required
        />
      </Field>

      <Field
        :errors="goal.fieldErrors"
        :show-field-errors="goal.fieldErrors ? goal.fieldErrors.length > 0 : false"
        name="title"
      >
        <label for="goal-title" class="label">Title for Milestone</label>
        <input id="goal-title" v-model="goal.title" type="text" required />
      </Field>

      <Field
        :errors="goal.fieldErrors"
        :show-field-errors="goal.fieldErrors ? goal.fieldErrors.length > 0 : false"
        name="description"
      >
        <label for="goal-description" class="label">Why are you raising this money?</label>
        <textarea id="goal-description" v-model="goal.description" class="textarea" required />
      </Field>

      <div v-if="allowRemove" class="btn-container">
        <button
          class="medium-button medium-button--inverted"
          :disabled="!allowRemove"
          @click="removeGoal"
        >
          Remove Goal
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Field from '@/components/Field'

export default {
  name: 'EditGoalCard',
  components: {
    Field,
  },
  props: {
    goal: {
      type: Object,
      default: () => {},
    },
    allowRemove: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newGoal: {},
      loading: false,
    }
  },
  methods: {
    removeGoal() {
      this.$emit('remove-goal')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/cards';
@import '../styles/mixins/buttons';
@import '../styles/forms';
@import '../styles/layout';

.card {
  @include card-w-borders();
}

.amount-container {
  display: flex;
  align-items: baseline;

  input {
    margin-left: 0.5rem;
  }
}
</style>
